import { gql } from '@apollo/client';

export const UPDATE_USER_ONG = gql`
  mutation UpdateUserOng($id: ID!, $data: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $data) {
      data {
        id
        attributes {
          firstname
          ong
        }
      }
    }
  }
`;
